module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-500.de95b8bf.eot";